import { render, staticRenderFns } from "./SeatComputerIcon.vue?vue&type=template&id=5e39040e"
import script from "./SeatComputerIcon.vue?vue&type=script&lang=js"
export * from "./SeatComputerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports